import React from 'react';
import { type IHostProps } from '@wix/yoshi-flow-editor';
import { getTPASettignsLiveSiteEditingDeprecated } from '@wix/communities-blog-client-common';
import { connect } from '../../../common/components/runtime-context';
import { getLayoutPostSize } from '../../../common/selectors/app-settings-selectors';
import { type Actions, type AppState } from '../../../common/types';
import CreatePostButtonMobile from './create-post-button-mobile';
import PageTabs, { ALIGNMENT } from './page-tabs';
import styles from './my-posts-frame-mobile.scss';

type Props = {
  children?: React.ReactNode;
  /**
   * NOTE: nothing supplies this — the mapper below provides
   * `isLiveSiteEditingEnabled`. Pre-existing on master, so the mobile
   * create-post button always renders. Left as-is.
   */
  isLiveSiteEditorDisabled?: boolean;
} & ReturnType<typeof mapRuntimeToProps>;

const MyPostsFrameMobile = ({ children, layoutPostSize, isLiveSiteEditorDisabled }: Props) => (
  <section
    className={styles.root}
    style={{ '--width': layoutPostSize ? `${layoutPostSize}px` : undefined }}
  >
    <PageTabs alignment={ALIGNMENT.center} />
    <section className={styles.main}>
      <div className={styles.createPostButton}>
        {!isLiveSiteEditorDisabled && <CreatePostButtonMobile />}
      </div>
      {children}
    </section>
  </section>
);

const mapRuntimeToProps = (
  state: AppState,
  _ownProps: {},
  _actions: Actions,
  host: IHostProps,
) => ({
  layoutPostSize: getLayoutPostSize({
    state,
    hostWidth: host.dimensions.width || undefined,
  }),
  isLiveSiteEditingEnabled: !getTPASettignsLiveSiteEditingDeprecated(state),
});

export default connect(mapRuntimeToProps)(MyPostsFrameMobile);
